@if(!CreatingTally){
<rms-mod width="100%">
  <div class="inventory-header">
    <div class="inventory-header-actions">
      <button class="btn-bg-red" mat-button (click)="ReturnToList()"><mat-icon>arrow_back</mat-icon>Return To List</button>
      <button class="btn-bg-blue" mat-stroked-button [matMenuTriggerFor]="ReportMenu">Reports</button>
      <button *ngIf="!InventoryItem.ChildKind" class="btn-bg-blue" mat-stroked-button [matMenuTriggerFor]="ActionsMenu">Actions</button>
      <button *ngIf="InventoryItem.ChildKind === 'Slack' && !InventoryItem.ProcessedDate" class="btn-bg-green" mat-stroked-button (click)="childActions?.openCompletionDialog()">Complete Slack</button>
      <button *ngIf="InventoryItem.ChildKind === '22lb Box' && !InventoryItem.ProcessedDate" class="btn-bg-green" mat-stroked-button (click)="childActions?.openCompletionDialog()">Complete 22lb Box </button>
      <button *ngIf="InventoryItem.ChildKind === 'Convert SKU' && !InventoryItem.ProcessedDate" class="btn-bg-green" mat-stroked-button (click)="childActions?.openCompletionDialog()">Complete SKU</button>
    </div>
    <app-inventory-website-visibility [invisible]="!!InventoryItem.WebInvisible"
                                      [disabled]="savingWebsiteVisibility" (invisibleChange)="setWebsiteInvisible($event)"></app-inventory-website-visibility>
    <div class="inventory-heading">
      <div class="inventory-identity">
        <span class="reference-label">Reference #{{InventoryItem.InventoryID}}</span>
        <span class="purchase-order-label">PO #{{InventoryItem.PurchaseOrderID}}</span>
        <span *ngIf="InventoryItem.ChildKind" class="inventory-kind"
              [class.inventory-kind--slack]="InventoryItem.ChildKind === 'Slack'"
              [class.inventory-kind--box]="InventoryItem.ChildKind === '22lb Box'"
              [class.inventory-kind--convert]="InventoryItem.ChildKind === 'Convert SKU'"
              [class.inventory-kind--transfer]="InventoryItem.ChildKind === 'Transfer'">{{InventoryItem.ChildKind}}</span>
        <span *ngIf="InventoryItem.Cancelled" class="inventory-cancelled">Order cancelled</span>
      </div>
      <h1>{{InventoryItem.InventoryTypeName}}</h1>
      <span class="inventory-position">{{InventoryItem.FinalPosition}}</span>
    </div>
  </div>
  <mat-menu #ReportMenu>
    @for(report of InventoryReports; track $index){
    <button mat-menu-item>{{report.label}}</button>
    }
  </mat-menu>
  <mat-menu #ActionsMenu>
    <button mat-menu-item (click)="childActions?.openSlackDialog()">Create Slack</button>
    <button mat-menu-item (click)="childActions?.open22lbBoxDialog()">Create 22lb Box</button>
    <button mat-menu-item (click)="childActions?.openConvertSkuDialog()">Convert SKU</button>
    <button mat-menu-item (click)="OpenInventoryTransferDialog()">Transfer Inventory</button>
  </mat-menu>
  <app-inventory-child-actions [inventoryItem]="InventoryItem" (childInventoryCreated)="onChildInventoryCreated($event)" (childInventoryUpdated)="onChildUpdated()"></app-inventory-child-actions>
  <rms-tab-group>

    <rms-tab label="Basic">
      <ng-template>
        <form #InventoryBasicForm="ngForm" class="inventory-basic-form">
          <div class="inventory-basic-layout">
          <section class="inventory-shipping" aria-label="Shipping and reference details">
            <h2>Shipping &amp; reference details</h2>
            <div class="inventory-field-grid">
            <rms-input name="Marks" label="Marks" [(ngModel)]="InventoryItem.Marks"></rms-input>
            <rms-input name="SupplierReffNumber" label="Supplier Ref #" [(ngModel)]="InventoryItem.SupplierReffNumber"></rms-input>
            <rms-input name="BookingNumber" label="Booking Number" [(ngModel)]="InventoryItem.BookingNumber"></rms-input>
            <rms-input name="Vessel" label="Vessel" [(ngModel)]="InventoryItem.Vessel"></rms-input>
            <rms-select name="InboundWeighingOption" label="Inbound Weighing Option" [(ngModel)]="InventoryItem.InboundWeighingOption" [options]="InventoryData?.InboundWeighingOptions" labelKey="InboundWeighingOptionName" valueKey="InboundWeighingOptionID"></rms-select>
            <rms-select name="InboundUnloadingOption" label="Inbound Unloading Option" [(ngModel)]="InventoryItem.InboundUnloadingOption" [options]="InventoryData?.InboundUnloadingOptions" labelKey="InboundUnloadingOptionName" valueKey="InboundUnloadingOptionID"></rms-select>
            <rms-select name="PortOfOrigin" label="Port Of Origin" [(ngModel)]="InventoryItem.PortOfOrigin" [options]="InventoryData?.OriginPorts" labelKey="origin_port_name" valueKey="origin_port_id"></rms-select>
            <rms-select name="ArrivalPort" label="Arrival Port" [(ngModel)]="InventoryItem.ArrivingPort" [options]="InventoryData?.ArrivalPorts" labelKey="entry_port_name" valueKey="entry_port_id"></rms-select>
            <rms-select name="ArrivalTerminal" label="Arrival Terminal" [(ngModel)]="InventoryItem.ArrivingTerminal" [options]="InventoryData?.ArrivalTerminals" labelKey="TerminalName" valueKey="TerminalID"></rms-select>
            <rms-select name="CustomsEntry" label="Customs Location" [(ngModel)]="InventoryItem.CustomsLocation" [options]="InventoryData?.ArrivalPorts" labelKey="entry_port_name" valueKey="entry_port_id"></rms-select>
            <rms-select name="DrayageCompany" label="Drayage Company" [(ngModel)]="InventoryItem.DrayageCompany" [options]="InventoryData?.DrayageCarriers" labelKey="CompanyName" valueKey="ID"></rms-select>
            <rms-input name="Broker" label="Broker" [(ngModel)]="InventoryItem.Broker"></rms-input>
            <rms-select name="FinalDestinationWarehouse" label="Final Destination Warehouse" [(ngModel)]="InventoryItem.FinalDestinationWarehouseID" [options]="InventoryData?.DestinationWarehouses" labelKey="LocationName" valueKey="LocationID"></rms-select>
            <rms-input name="ContainerNumber" label="Container Number" [(ngModel)]="InventoryItem.ContainerNumber"></rms-input>
            <rms-input name="SealNumber" label="Seal Number" [(ngModel)]="InventoryItem.SealNumber"></rms-input>
            <rms-input name="BillOfLading" label="Bill Of Lading" [(ngModel)]="InventoryItem.BillOfLadingNumber"></rms-input>
            <rms-input name="PreferredSSLLine" label="Preferred SSL" [(ngModel)]="InventoryItem.PreferredSSLine"></rms-input>
            <rms-input name="SupplierInvoiceNumber" label="Supplier Invoice Number" [(ngModel)]="InventoryItem.SupplierSaleNo"></rms-input>
            <rms-textarea name="InboundInstructions" label="Inbound Instructions" [(ngModel)]="InventoryItem.MiscInboundInstructions"></rms-textarea>
            <fieldset class="rms-fieldset shipment-checks">
              <legend>Shipment clearance</legend>
              <div class="clearance-options">
                <rms-checkbox name="FreightClear" label="Freight Clear" [(ngModel)]="InventoryItem.FreightReleased"></rms-checkbox>
                <rms-checkbox name="CustomsClear" label="Customs Clear" [(ngModel)]="InventoryItem.CustomsReleased"></rms-checkbox>
                <rms-checkbox name="FDAClear" label="FDA Clear" [(ngModel)]="InventoryItem.FDAReleased"></rms-checkbox>
              </div>
            </fieldset>
            </div>
          </section>
          <aside class="inventory-sidebar" aria-label="Inventory and document status">
<fieldset class="rms-fieldset document-status"><legend>Mandatory documents</legend><p class="section-hint">Manage files in the Documents tab.</p><div class="document-status-list">
 @for(doc of mandatoryDocs; track doc.id){
 <div class="document-status-row" [class.document-present]="haveDoc(doc)">
 <mat-icon aria-hidden="true">{{haveDoc(doc) ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
 <span>{{doc.label}}</span><small>{{haveDoc(doc) ? 'On file' : 'Not on file'}}</small>
 </div>
 }
 </div></fieldset>
<details class="supporting-documents"><summary>Supporting documents</summary><div class="document-status-list">
 @for(doc of supportingDocs; track doc.id){
 <div class="document-status-row" [class.document-present]="haveDoc(doc)">
 <mat-icon aria-hidden="true">{{haveDoc(doc) ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
 <span>{{doc.label}}</span><small>{{haveDoc(doc) ? 'On file' : 'Not on file'}}</small>
 </div>
 }
 </div></details>
            <fieldset class="rms-fieldset inventory-summary">
              <legend>Inventory Data</legend>
              <div class="fields">
                <rms-input name="availqty" [disabled]="true" label="Available Bags" [(ngModel)]="InventoryItem.AvailableQty"></rms-input>
                <rms-number *ngIf="!ChildKind" name="bagsordered" label="Bags Ordered" [disabled]="true" [ngModel]="InventoryItem.BagsOrdered"></rms-number>
                <rms-number *ngIf="InventoryItem.BagsInbounded" name="BagsIn" label="Bags In" [disabled]="true" [ngModel]="InventoryItem.BagsInbounded"></rms-number>
                <rms-input *ngIf="!ChildKind" type="decimal" name="NetWeight" [disabled]="true" label="Net Weight" [(ngModel)]="InventoryItem.NetWeight"></rms-input>
                <rms-number *ngIf="ChildKind === '22lb Box'" name="boxesOrdered" label="Box Ordered" [disabled]="true" [ngModel]="InventoryItem.BagsOrdered"></rms-number>
                <rms-input *ngIf="ChildKind === 'Slack'" type="decimal" name="slackWeightOrdered" [disabled]="true" label="Slack Weight Ordered" [ngModel]="InventoryItem.NetWeight"></rms-input>
                <rms-number *ngIf="ChildKind === 'Convert SKU'" name="bagsReconciled" label="Bags To Recondition" [disabled]="true" [ngModel]="InventoryItem.BagsOrdered"></rms-number>
                <rms-input *ngIf="InventoryItem.WeightReceived" type="decimal" name="weightrecieved" [disabled]="true" label="Weight Received" [(ngModel)]="InventoryItem.WeightReceived"></rms-input>
                <rms-input type="currency" [disabled]="true" name="PurchasePrice" label="Gross Purchase Price" [(ngModel)]="InventoryItem.PricePound"></rms-input>
                <rms-input type="currency" [disabled]="true" name="DifferentialEquivalent" label="Purchase differential equivalent / lb" [ngModel]="costingSummary.purchaseDifferentialEquivalent"></rms-input>
                <rms-input [disabled]="true" name="FinalPosition" label="Final Position" [ngModel]="InventoryItem.FinalPosition"></rms-input>
              </div>
            </fieldset>
          </aside>
          </div>
          <div class="inventory-save-bar">
            <span role="status">{{InventoryBasicForm.dirty ? 'Unsaved changes' : 'No unsaved changes'}}</span>
            <button type="button" mat-button (click)="UpdateInventoryDetails()" class="btn-bg-green" [disabled]="InventoryBasicForm.pristine || InventoryBasicForm.invalid">
              <mat-icon>save</mat-icon>Save changes
            </button>
          </div>
        </form>
      </ng-template>
    </rms-tab>
    <rms-tab label="Costing">
      <ng-template>

        <div class="inventory-costing">

          <div class="costing-content">

            <!-- =====================================================
   COSTING STATUS
   ===================================================== -->

            <div class="costing-status-bar"
                 [class.actual]="costingSummary.actual"
                 [class.estimated]="!costingSummary.actual">


              <div class="costing-status-text">
                <mat-icon [ngStyle]="{color: costingSummary.actual ? 'green' : 'orange'}">
                  {{ costingSummary.actual ? 'check_circle' : 'directions_boat' }}
                </mat-icon>
                @if (costingSummary.actual) {

                <strong>Actual Landed Costing</strong>

                <span>
                  Actual landed cost + financing from Title Date to Date In
                  + warehouse financing and storage
                </span>

                }
                @else {

                <strong>Estimated Landed Costing</strong>

                <span>
                  Purchase cost + estimated shipment handling + warehouse financing and storage after arrival.
                </span>

                }

              </div>

              @if(hasCostingDifferential) {
              <button type="button" class="costing-basis-toggle" role="switch" aria-label="Display differential costing" [attr.aria-checked]="costingMode === 'differential'" [class.is-differential]="costingMode === 'differential'" (click)="setCostingMode(costingMode === 'fixed' ? 'differential' : 'fixed')" matTooltip="Switch between full dollar cost and its differential equivalent">
                <span [class.selected]="costingMode === 'fixed'">Fixed</span><span class="basis-toggle-track" aria-hidden="true"><span></span></span><span [class.selected]="costingMode === 'differential'">Differential</span>
              </button>
              }

            </div>


            <!-- =====================================================
   SUMMARY CARDS
   ===================================================== -->


            @if(!costingSummary.fixed) {
              <div class="purchase-cost-breakdown">Purchase cost: {{displayCost(costingSummary.differential)}} differential + {{displayCost(costingSummary.basis)}} market at purchase = <strong>{{displayCost(costingSummary.purchase)}}</strong></div>
            }
            @if(costingSummary.missing.length) {
              <p role="status" class="purchase-cost-breakdown">Costing incomplete: missing {{costingSummary.missing.join(', ')}}.</p>
            }
            <div class="pricing-summary">
              <div class="summary-card landed-cost costing-info-card">
                <div class="summary-card-top">
                  <div class="summary-label">{{costingSummary.actual ? 'Landed Cost' : 'Estimated Landed Cost'}}</div>
                  <button type="button" mat-icon-button class="cost-info-button" [matMenuTriggerFor]="costingMenu" (click)="costingStage='landed'" [attr.aria-label]="costingSummary.actual ? 'View landed cost calculation' : 'View estimated landed cost calculation'"><mat-icon>info_outline</mat-icon></button>
                </div>
                <div class="summary-value">{{displayCost(costingSummary.displayLanded)}}</div>
                <div class="summary-card-detail">{{costingSummary.actual ? 'Actual landed charges' : (InventoryItem.ShipmentTypeID == 1 && InventoryItem.ShippingTerm != 4 ? 'Calculated FOB-to-ex-warehouse charges' : 'Ex-warehouse handling')}} · {{costingMode === 'fixed' ? 'Fixed cost' : 'Differential equivalent'}}</div>
              </div>
              <div class="summary-card aged-cost costing-info-card">
                <div class="summary-card-top">
                  <div class="summary-label">Aged Cost</div>
                  <button type="button" mat-icon-button class="cost-info-button" [matMenuTriggerFor]="costingMenu" (click)="costingStage='aged'" aria-label="View aged calculation"><mat-icon>info_outline</mat-icon></button>
                </div>
                <div class="summary-value">{{displayCost(costingSummary.displayAged)}}</div>
                <div class="summary-card-detail">{{InventoryItem.DateIn ? 'Includes warehouse financing and storage' : 'No warehouse financing or storage before arrival'}}</div>
              </div>
              <div class="summary-card current-total">
                <div class="summary-label">Misc adjustments</div>
                <div class="summary-value">{{costingSummary.adjustments | currency:'USD':'symbol':'1.4-4'}}</div>
              </div>
              <div class="summary-card final-cost costing-info-card">
                <div class="summary-card-top">
                  <div class="summary-label">Aged Cost with Misc Adjustments</div>
                  <button type="button" mat-icon-button class="cost-info-button" [matMenuTriggerFor]="costingMenu" (click)="costingStage='final'" aria-label="View aged cost with misc adjustments calculation"><mat-icon>info_outline</mat-icon></button>
                </div>
                <div class="summary-value">{{displayCost(costingSummary.displayFinal)}}</div>
                <div class="summary-card-detail">Aged cost + misc adjustments</div>
              </div>
            </div>

            <app-cost-adjustments [InventoryID]="InventoryItem.InventoryID"
                                  (adjustmentSaved)="refreshCostingFields()">
            </app-cost-adjustments>


            <!-- =====================================================
   LANDED COST MENU
   ===================================================== -->


            <mat-menu #costingMenu="matMenu" class="cost-calculation-menu">
              <div class="cost-menu-content" (click)="$event.stopPropagation()">
                <div class="cost-menu-title">{{costingStage === 'landed' ? (costingSummary.actual ? 'Landed Cost' : 'Estimated Landed Cost') : costingStage === 'aged' ? 'Aged Cost' : 'Aged Cost with Misc Adjustments'}} Calculation · {{costingMode === 'differential' ? 'Differential view' : 'Fixed view'}}</div>
                @if(costingSummary.fixed) {
                  <div class="cost-calc-row"><span>Fixed purchase price</span><strong>{{displayCost(costingSummary.purchase)}}</strong></div>
                } @else {
                  <div class="cost-calc-row"><span>Purchase differential</span><strong>{{displayCost(costingSummary.differential)}}</strong></div>
                  <div class="cost-operator">+</div>
                  <div class="cost-calc-row"><span>Market at purchase</span><strong>{{displayCost(costingSummary.basis)}}</strong></div>
                  <div class="cost-calc-row"><span>Purchase cost</span><strong>{{displayCost(costingSummary.purchase)}}</strong></div>
                }
                <div class="cost-operator">+</div>
                <div class="cost-calc-row"><span>{{costingSummary.actual ? 'Actual landed charges' : InventoryItem.ShipmentTypeID == 1 && InventoryItem.ShippingTerm != 4 ? 'FOB-to-ex-warehouse charges' : 'Ex-warehouse handling'}}</span><strong>{{displayCost(costingSummary.handling)}}</strong></div>
                @if(costingSummary.actual) {
                  <div class="cost-calc-row"><span>Financing on water · Title Date → Date In<br><small>{{costingSummary.rate | percent:'1.2-3'}} ÷ 360 × {{costingSummary.financeDays}} days × landed purchase cost</small></span><strong>{{displayCost(costingSummary.financing)}}</strong></div>
                }
                <div class="cost-calc-row final-total"><span>{{costingSummary.actual ? 'Landed cost' : 'Estimated landed cost'}}</span><strong>{{displayCost(costingSummary.landed)}}</strong></div>
                @if(costingStage !== 'landed') {
                  <div class="cost-calc-row"><span>Warehouse financing · Date In → today<br>@if(costingSummary.warehouseFinancing !== 0) {<small>{{costingSummary.rate | percent:'1.2-3'}} ÷ 360 × ({{costingSummary.warehouseFinanceDays}} days + 30 initial days) × {{displayCost(costingSummary.warehouseFinanceBasis)}} landed cost</small>} @else {<small>No warehouse financing before arrival.</small>}</span><strong>{{displayCost(costingSummary.warehouseFinancing)}}</strong></div>
                  <div class="cost-calc-row"><span>Warehouse storage · Date In → today<br>@if(InventoryItem.DateIn && costingSummary.storageDays != null) {<small>({{costingSummary.storageDays}} days + 30 initial days) ÷ 30 × 0.006</small>} @else if(!InventoryItem.DateIn) {<small>No storage before arrival.</small>} @else {<small>Storage day count unavailable.</small>}</span><strong>{{displayCost(costingSummary.storage)}}</strong></div>
                  <div class="cost-calc-row final-total"><span>Aged cost</span><strong>{{displayCost(costingSummary.aged)}}</strong></div>
                }
                @if(costingStage === 'final') {
                  <div class="cost-calc-row"><span>Misc adjustments</span><strong>{{displayCost(costingSummary.adjustments)}}</strong></div>
                  <div class="cost-calc-row final-total"><span>Aged cost with misc adjustments</span><strong>{{displayCost(costingSummary.final)}}</strong></div>
                }
                @if(costingMode === 'differential') {
                    <div class="cost-calc-row"><span>Less Market at purchase</span><strong>− {{displayCost(costingSummary.basis)}}</strong></div>
                    <div class="cost-calc-row final-total"><span>{{costingStage === 'landed' ? 'Landed' : costingStage === 'aged' ? 'Aged' : 'Aged with misc adjustments'}} differential equivalent</span><strong>{{displayCost(costingStage === 'landed' ? costingSummary.displayLanded : costingStage === 'aged' ? costingSummary.displayAged : costingSummary.displayFinal)}}</strong></div>
                    <p class="cost-basis-explanation">Financing uses the full landed dollar cost, including financing on water when applicable.</p>
                  }
                  @if(costingSummary.actual && costingStage === 'landed') {
                  <div class="cost-estimate-footnote">Estimated landed cost: <strong>{{displayCost(costingSummary.estimatedLanded)}}</strong><br>Purchase cost + fobtoexwhse (Estimated financing included)</div>
                }
              </div>
            </mat-menu>


          </div>

        </div>

      </ng-template>
    </rms-tab>    <rms-tab label="Tracking &amp; Dates">
      <ng-template>
        <div class="tracking-view">
          <p class="tab-guidance">Dates save when changed. ETD, afloat, and ETA changes require a traffic note.</p>
          <div class="tracking-grid">
            <fieldset class="rms-fieldset">
              <legend>Samples</legend>
              <div class="date-fields">
                <div style="margin-top:8px; margin-bottom:8px"><rms-checkbox name="SampleBeforeStripping" label="Sample Before Stripping" [(ngModel)]="InventoryItem.SampleBeforeStripping" (ngModelChange)="onSampleDatesChanged()"></rms-checkbox></div>
                <rms-date name="SampleReceived" label="Preship Sample Received" [(ngModel)]="InventoryItem.PSSReceivedDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <rms-date name="SampleApprovalDate" [disabled]="true" label="Preship Approved" [(ngModel)]="InventoryItem.PSSApprovalDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <rms-date name="SampledDate" label="Sampled At Warehouse" [(ngModel)]="InventoryItem.SampledAtWarehouseDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <rms-date name="ArrivalApprovalDate" [disabled]="true" label="Arrival Approved" [(ngModel)]="InventoryItem.ArrivalApprovalDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <button class="btn-bg-green" mat-button>Print Sample Label</button>
              </div>
            </fieldset>
            <fieldset class="rms-fieldset">
              <legend>Tracking</legend>
              <div class="date-fields">
                <rms-date name="ETD" label="Estimated Departure (ETD)" [(ngModel)]="InventoryItem.ETDDateLogistics" (ngModelChange)="onTrafficDateChange()"></rms-date>
                <rms-date name="Afloat" label="Afloat" [(ngModel)]="InventoryItem.AfloatDate" (ngModelChange)="onTrafficDateChange()"></rms-date>
                <rms-date name="ETA" label="Estimated Arrival (ETA)" [(ngModel)]="InventoryItem.VesselETA" (ngModelChange)="onTrafficDateChange()"></rms-date>
                <rms-date name="WTA" label="Warehouse Appointment (WTA)" [(ngModel)]="InventoryItem.DrayageAppointmentDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <rms-date name="ArrivalDate" label="Container Delivered" [(ngModel)]="InventoryItem.ArrivalDateWarehouse" (ngModelChange)="onSampleDatesChanged()"></rms-date>
                <button class="btn-bg-green" mat-button (click)="viewTrafficNotes()">View Traffic Notes</button>
              </div>
            </fieldset>
            <fieldset class="rms-fieldset"><legend>Warehouse &amp; ownership</legend><div class="date-fields">
            @if(!InventoryItem.ProcessedDate){
            <rms-date name="DateIn" label="Date In" [(ngModel)]="InventoryItem.DateIn" (ngModelChange)="onSampleDatesChanged()"></rms-date>
            }
            @else{
            <rms-date name="ProcessedDate" label="Processed Date" [(ngModel)]="InventoryItem.ProcessedDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
            }
            <rms-date name="TitleDate" label="Title Date" [(ngModel)]="InventoryItem.TitleDate" (ngModelChange)="onSampleDatesChanged()"></rms-date>
            </div></fieldset>
          </div>
        </div>
      </ng-template>
    </rms-tab>
    <rms-tab label="Cupping">
      <ng-template>
        <p class="tab-guidance">Compare preship and arrival results. Scores are read-only here.</p>
        <div class="cupping-grid">
          <fieldset class="rms-fieldset">
            <legend>Preship Scores</legend>
            @if(InventoryItem.PreshipCupping){
            <div style="display:flex; flex-direction:column; width:100%">
              <h3>SCA: {{InventoryItem.PreshipCupping.SCAATotal}}</h3>
              <rms-data-slider label="Acidity" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="InventoryItem.PreshipCupping.Acidity" [disabled]="true"></rms-data-slider>
              <rms-data-slider label="Body" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="InventoryItem.PreshipCupping.Body" [disabled]="true"></rms-data-slider>
              <rms-data-slider label="Sweetness" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="InventoryItem.PreshipCupping.Sweetness" [disabled]="true"></rms-data-slider>
              <rms-data-slider label="Aftertaste" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="InventoryItem.PreshipCupping.Aftertaste" [disabled]="true"></rms-data-slider>
              <rms-data-slider label="Overall" [step]="0.25" [min]="6" [max]="10" [(ngModel)]="InventoryItem.PreshipCupping.Overall" [disabled]="true"></rms-data-slider>
              <br />
              @if(InventoryItem.TimesPreshipRecupped){
              <rms-input label="Times Recupped" [ngModel]="InventoryItem.TimesPreshipRecupped" [disabled]="true"></rms-input>
              }
            </div>
            } @else { <p class="tab-empty">No preship cupping results on file.</p> }
          </fieldset>
          <fieldset class="rms-fieldset">
            <legend>Arrival Scores</legend>
            @if(InventoryItem.ArrivalCupping){
            <div style="display:flex; flex-direction:column; width:100%">
              <h3>SCA: {{InventoryItem.ArrivalCupping.SCAATotal}}</h3>
              <rms-data-slider [min]="6" [max]="10" label="Acidity" [step]="0.25" [(ngModel)]="InventoryItem.ArrivalCupping.Acidity" [disabled]="true"></rms-data-slider>
              <rms-data-slider [min]="6" [max]="10" label="Body" [step]="0.25" [(ngModel)]="InventoryItem.ArrivalCupping.Body" [disabled]="true"></rms-data-slider>
              <rms-data-slider [min]="6" [max]="10" label="Sweetness" [step]="0.25" [(ngModel)]="InventoryItem.ArrivalCupping.Sweetness" [disabled]="true"></rms-data-slider>
              <rms-data-slider [min]="6" [max]="10" label="Aftertaste" [step]="0.25" [(ngModel)]="InventoryItem.ArrivalCupping.Aftertaste" [disabled]="true"></rms-data-slider>
              <rms-data-slider [min]="6" [max]="10" label="Overall" [step]="0.25" [(ngModel)]="InventoryItem.ArrivalCupping.Overall" [disabled]="true"></rms-data-slider>
              <br />
              @if(InventoryItem.TimesArrivalRecupped){
              <rms-input label="Times Recupped" [ngModel]="InventoryItem.TimesArrivalRecupped" [disabled]="true"></rms-input>
              }
            </div>
            }
            @else{
            <div style="display:flex; justify-content:center;">
              <p class="tab-empty">No arrival cupping results on file.</p>
            </div>
            }
          </fieldset>
          <fieldset class="rms-fieldset">
            <legend>Flavor Notes</legend>

            <div style="display:flex; flex-direction:column; width:100%;">
              @if(PrimaryFlavorNote){
              <div style="display:flex; flex-direction:column; align-items:center; width:100%;">
                <h2 style="margin:0 0 10px 0;">Primary</h2>

                <div class="large-flavor-note-card">
                  <img [src]="PrimaryFlavorNote.url"
                       [alt]="PrimaryFlavorNote.FlavorNoteName" />
                </div>

                <h3 style="margin:8px 0 18px 0;">
                  {{ PrimaryFlavorNote.FlavorNoteName }}
                </h3>
              </div>
              }
              @else{
              <div style="display:flex; justify-content:center;">
                <p class="tab-empty">No flavor notes on file.</p>
              </div>
              }

              @if(SecondaryFlavorNotes.length > 0){
              <div style="display:flex; flex-direction:column; align-items:center; width:100%;">
                <h3>Secondary</h3>
                <div style="display:flex; flex-wrap:wrap; gap:12px; justify-content:center;">
                  @for(note of SecondaryFlavorNotes; track note.FlavorNoteID || note.path){
                  <div class="flavor-note-card">
                    <img [src]="note.url"
                         [alt]="note.FlavorNoteName"
                         style="width:70px; height:70px; object-fit:contain;" />

                    <div class="flavor-note-text">
                      {{ note.FlavorNoteName }}
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </fieldset>
        </div>
      </ng-template>
    </rms-tab>
    <rms-tab label="Inbound Tally">
      <ng-template>
        <section class="tally-view">
        <p class="tab-guidance">Review the tally sheet, or create one to record received bags and weight.</p>
        @if(ContainsTallySheet()){
        @if(!FinalizeInboundView){
        @if(isManagement()){<div class="tab-actions"><button mat-stroked-button (click)="editTally()" class="btn-bg-blue">Edit Tally</button>@if(!InventoryItem.DateIn){<button mat-stroked-button class="btn-bg-green" (click)="StartFinalizeInbound()">Finalize Inbound</button>}</div>}
        <div class="tally-preview"><rms-file-preview [path]="TallySheetPath"></rms-file-preview></div>
        }
        @else{
        @if(finalizeData){
        <form #FinalizeInboundForm="ngForm" class="tally-form">
          <div class="tally-quantities">
            <div style="display:flex; flex-direction:column; align-items:center">
              <h3>Expected Bags: {{finalizeData.BagsExpected}}</h3>
              <rms-input type="decimal" [required]="true" name="bags" label="Bags Received" [(ngModel)]="finalizeData.BagsWeighed"></rms-input>
            </div>
            <div style="display:flex; flex-direction:column; align-items:center">
              <h3>Expected Weight: {{finalizeData.WeightExpected}}</h3>
              <rms-input type="decimal" [required]="true" name="weight" label="Weight Received" [(ngModel)]="finalizeData.TotalWeight"></rms-input>
            </div>
            <div style="display:flex; flex-direction:column; align-items:center">
              <h3>Weight Per Bag: {{InventoryItem.NetWeight}}</h3>
            </div>
          </div>
          <rms-date [required]="true" name="datein" label="Date In" [(ngModel)]="InventoryItem.DateIn"></rms-date>
          <div class="tab-actions">
            <button type="button" mat-button class="btn-bg-green" [disabled]="FinalizeInboundForm.invalid" (click)="FinalizeInbound()">Finalize inbound</button>
            <button type="button" mat-button class="btn-bg-red" (click)="finalizeData = null; FinalizeInboundView = false">Cancel</button>
          </div>
        </form>
        }
        }
        }
        @else{
        <div class="tally-empty">
          <mat-icon aria-hidden="true">assignment</mat-icon>
          <h2>No tally sheet yet</h2>
          <p>Create a tally in RMS or upload a third-party tally sheet below.</p>
          <button type="button" mat-button class="btn-bg-green" (click)="openTallyCreator()">Create tally sheet</button>
          <rms-uploader label="3rd Party Tally Sheet"
                        hint="PDF, images, or Word documents up to 15MB"
                        accept=".pdf,.doc,.docx,image/*"
                        [multiple]="false"
                        [maxSizeMB]="15"
                        [autoUpload]="true"
                        [uploader]="handleWeightCertUpload">
          </rms-uploader>
        </div>
        }
        </section>
      </ng-template>
    </rms-tab>
    <rms-tab label="Documents">
      <ng-template>
        <div class="inventory-documents">
          <p class="tab-guidance">Select a folder or document to preview it. Use the upload area to add files to this purchase order.</p>
          <rms-file-explorer leftWidth="100%" rightWidth="100%" height="100%" [rootPath]="poInventoryRootPath" (Uploaded)="UploadDocument($event)"></rms-file-explorer>
        </div>
      </ng-template>
    </rms-tab>
    <rms-tab label="Family tree">
      <ng-template><app-inventory-family-tree [inventoryID]="InventoryItem.InventoryID"></app-inventory-family-tree></ng-template>
    </rms-tab>
  </rms-tab-group>
</rms-mod>
}
@else{
<app-tally-creator [InventoryItem]="tallyData" [existingTally]="existingTally" (closeTallyCreator)="closeTallyCreator()"></app-tally-creator>
}
